export const SHOPIFY_API_LIBRARY_VERSION = '11.13.0';
